import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
export var ImprovementHeading = function (_a) {
    var item = _a.item;
    var balancing = item.balancing, icon = item.icon, locaKey = item.locaKey, level = item.level;
    var modifierIconProps = {
        icon: IdIcon.PlusResearchIcn,
        position: IdBadgePosition.BottomLeft,
        styleId: IdStyles.IconSmall,
    };
    var totalLevels = balancing.level.length;
    return (React.createElement("div", { className: "improvement__heading" },
        React.createElement("div", null,
            React.createElement(IconWithModifier, { styleId: IdStyles.IconExtraLarge, icon: icon, modifierIconProps: modifierIconProps, tooltipLoca: locaKey })),
        React.createElement("div", { className: "improvement__heading-text" },
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(TextLoca, { id: balancing.locaKeyTitle }),
                "\u00A0",
                React.createElement(TextLocaValueProportional, { available: level, required: totalLevels })),
            React.createElement(TextLoca, { id: balancing.locaKeyDesc, className: IdStyles.TextNormal }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementHeading.tsx
// module id = 2691
// module chunks = 3